<div class="w-full h-full flex flex-col gap-25">
  <h2 class="flex flex-col items-center">
    <img src="logo-thalea.svg" class="w-20.5" />
  </h2>

  <div class="h-full flex flex-col items-center justify-center">
    <div class="flex flex-col items-center gap-[1.2rem] w-full sm:w-[25rem]">
      <div class="w-full">
        <h2 class="text-[#09090B] text-center text-xl font-semibold leading-8">
          Conferma email
        </h2>

        <p class="text-[#71717A] text-center text-sm font-normal leading-5">
          Per email ti è arrivato un codice di 6 cifre inseriscilo qui
        </p>
      </div>

      <hlm-tabs tab="confirm" class="w-full">
        <form
          hlmTabsContent="confirm"
          [formGroup]="form"
          (ngSubmit)="confirmSignUp()"
        >
          <section class="flex flex-col gap-[1.2rem]" hlmCard>
            <div
              class="px-5 py-0 pt-5 flex flex-col gap-[1.2rem]"
              hlmCardContent
            >
              <label class="block" hlmLabel>
                <!-- Codice* -->
                <hlm-form-field class="mt-1.5 w-full">
                  <input formControlName="code" type="hidden" hlmInput />
                  <brn-input-otp
                    hlm
                    [maxLength]="6"
                    inputClass="disabled:cursor-not-allowed"
                    formControlName="code"
                    [transformPaste]="transformPaste"
                    (completed)="confirmSignUp()"
                    class="w-full flex justify-center"
                  >
                    <div hlmInputOtpGroup>
                      <hlm-input-otp-slot index="0" />
                      <hlm-input-otp-slot index="1" />
                      <hlm-input-otp-slot index="2" />
                      <hlm-input-otp-slot index="3" />
                      <hlm-input-otp-slot index="4" />
                      <hlm-input-otp-slot index="5" />
                    </div>
                  </brn-input-otp>
                  <hlm-error
                    >Il codice è obbligatorio e deve essere di 6
                    cifre</hlm-error
                  >
                </hlm-form-field>
              </label>
            </div>

            <div class="p-5 pt-0" hlmCardFooter>
              <button hlmBtn [disabled]="isDisabled()" class="w-full">
                @if (isLoading()) {
                  <hlm-spinner />
                } @else {
                  Procedi
                }
              </button>
            </div>
          </section>
        </form>
      </hlm-tabs>

      <div class="flex items-center">
        <span class="text-base">Non ti è arrivato il codice?</span>
        <button
          hlmBtn
          variant="link"
          [disabled]="isLoading()"
          class="w-auto text-base"
          (click)="onResendCodeClick()"
          type="button"
        >
          Invia di nuovo
        </button>
      </div>
    </div>
  </div>
</div>

